function sortObjectKeys(obj) {
  if (!obj) return [];
  return Object.keys(obj).sort();
}

export default sortObjectKeys;
